<template>
  <div class="detail-layer-wrap">
    <div class="layer-head-wrap">
      <div class="btn-wrap">
        <img
          :src="newClose"
          alt=""
          class="close-btn"
          @click="closeLayer"
        >
      </div>
      <div class="layer-head-main">
        <div class="company-info">
          <span
            class="company-name"
            :title="baseInfoItem.name"
          >
            {{baseInfoItem.name}}
          </span>
          <div class="contacts-wrap">
            <table>
              <tr>
                <td
                  width="40%"
                  class="text-space"
                >
                  消防安全负责人：
                </td>
                <td
                  width="15%"
                  class="text-space"
                  :title="baseInfoItem.leader"
                >
                  {{baseInfoItem.leader}}
                </td>
                <td
                  width="20%;"
                  style="margin-left:20px"
                  class="text-space"
                >
                  联系方式：
                </td>
                <td
                  width="25%"
                  class="text-space"
                >
                  {{baseInfoItem.leaderPhone}}
                </td>
              </tr>
              <tr>
                <td class="text-space">
                  专兼职消防管理人：
                </td>
                <td
                  class="text-space"
                  :title="baseInfoItem.fireCustodianName"
                >
                  {{baseInfoItem.fireCustodianName}}
                </td>
                <td class="text-space">
                  联系方式：
                </td>
                <td class="text-space">
                  {{baseInfoItem.fireCustodianPhone}}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 按钮组 -->
        <div class="option-group">
          <div class="update-wrap">
            <span class="auto-text">自动刷新</span>
            <i-switch
              v-model="switch1"
              @on-change="switchChange"
            />
            <Button
              type="primary"
              @click="update"
            >刷新</Button>
          </div>
          <ul class="time-wrap">
            <li
              v-for="(item, index) in timeArr"
              :key="index"
              :class="{'active': timeIndex == index}"
              @click="changeTime(index)"
            >
              {{item}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="layer-body-wrap"
      id="base-layer-detail-body"
    >
      <!-- 顶部按钮 -->
      <div class="option-wrap">
        <ul class="equal_ul">
          <li class="equal_li">
            <div class="table-wrap">
              <table style="line-height: 27px">
                <tr>
                  <td width="100px">组织机构代码 ：</td>
                  <td>
                    {{baseInfoItem.certificateNum == 'null' ? '' : baseInfoItem.certificateNum}}
                  </td>
                </tr>
                <tr>
                  <td>单位类别 ：</td>
                  <td>
                    {{baseInfoItem.industryCategoryName}}
                  </td>
                </tr>
                <tr>
                  <td>所属区域 ：</td>
                  <td>
                    {{baseInfoItem.areaName}}
                  </td>
                </tr>
                <tr>
                  <td>详细位置 ：</td>
                  <td>
                    {{baseInfoItem.address}}
                  </td>
                </tr>
                <tr>
                  <td>消防单位类别 ：</td>
                  <td>
                    {{(baseInfoItem.supervisionLevelCode == 1 || baseInfoItem.supervisionLevelCode == 2 || baseInfoItem.supervisionLevelCode == 3 || baseInfoItem.supervisionLevelCode == 4 || baseInfoItem.supervisionLevelCode == 5) ? '消防重点单位' : '其他安全消防单位'}}
                  </td>
                </tr>
                <tr>
                  <td>消防单位等级 ：</td>
                  <td>
                    {{baseInfoItem.supervisionLevelCode == '1' ? '一级消防安全重点单位' : baseInfoItem.supervisionLevelCode == '2' ? '二级消防安全重点单位' : baseInfoItem.supervisionLevelCode == '3' ? '三级消防安全重点单位' : baseInfoItem.supervisionLevelCode == '4' ? '四级消防安全重点单位' : '非消防安全重点单位'}}
                  </td>
                </tr>
              </table>
            </div>
          </li>
          <li
            class="equal_li"
            style="padding-left: 10px;"
          >
            <div class="map-wrap mapOneTwo">

              <div
                class="company-map"
                id="company-map"
              ></div>
              <!--这期下面功能先屏蔽-->
              <!-- <div class="map-img-wrap">
                <img src="../assets/images/company_layer/map-img.png" alt="">
                </div>-->

            </div>
          </li>
          <li class="equal_li">
            <div
              class="map-img-wrap"
              @click="optionBtn(6)"
            >
              <img
                src="../assets/images/company_layer/map-img.png"
                alt=""
              >
              <p>视频监控</p>
            </div>
          </li>
          <li class="equal_li">
            <div
              class="option-btn-wrap blockThree"
              style="padding-top: 10px;"
            >
              <ul>
                <li
                  v-for="(item, index) in optionBtnArr"
                  :key="index"
                  :class="{'active': optionBtnIndex === index}"
                  @click="optionBtn(index)"
                >
                  {{item.label + '（' + item.value + '）'}}
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <!-- 内容区 -->
      <!-- 消防运行情况 -->
      <div class="main-block-wrap">
        <div class="main-block-tit">
          消防运行情况
          <!--<img src="../assets/images/company_layer/tit-ico.png" alt="">-->
        </div>
        <ul class="main-block-ul">
          <li
            class="main-block-li"
            :class="{'active' : main_block_index === 0}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block1.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'hj' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('hj', '火警遗留未处理列表', 0)"
                >
                  火警遗留未处理
                  <span class="red">
                    {{fireControlObj.huojingObj.unhandleCount}}
                  </span>
                  条
                </p>
                <div class="sum-wrap">
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('hj1', '火警' + selectTime + '已处理列表', 0)"
                  >
                    <p class="sum green">
                      {{fireControlObj.huojingObj.handleCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'hj1' ? 'active' :　'' ]">
                        {{selectTime}}已处理数量
                      </span>
                    </p>
                  </div>
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('hj2', selectTime + '火警列表', 0)"
                  >
                    <p class="sum normal">
                      {{fireControlObj.huojingObj.totalCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'hj2' ? 'active' :　'' ]">
                        {{selectTime}}火警数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 1}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block2.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'bj' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('bj', '报警遗留未处理列表', 1)"
                >
                  报警遗留未处理
                  <span class="red">
                    {{fireControlObj.baojingObj.unhandleCount}}
                  </span>
                  条
                </p>
                <div class="sum-wrap">
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('bj1', '报警' + selectTime + '已处理列表', 1)"
                  >
                    <p class="green sum">
                      {{fireControlObj.baojingObj.handleCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'bj1' ? 'active' :　'' ]">
                        {{selectTime}}已处理数量
                      </span>
                    </p>
                  </div>
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('bj2', selectTime + '报警列表', 1)"
                  >
                    <p class="normal sum">
                      {{fireControlObj.baojingObj.totalCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'bj2' ? 'active' :　'' ]">
                        {{selectTime}}报警数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 2}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block3.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'yj' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('yj', '预警遗留未处理列表', 2)"
                >
                  预警遗留未处理
                  <span class="red">
                    {{fireControlObj.yujingObj.unhandleCount}}
                  </span>
                  条
                </p>
                <div class="sum-wrap">
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('yj1', '预警' + selectTime + '已处理列表', 2)"
                  >
                    <p class="green sum">
                      {{fireControlObj.yujingObj.handleCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'yj1' ? 'active' :　'' ]">
                        {{selectTime}}已处理数量
                      </span>
                    </p>
                  </div>
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('yj2', selectTime + '预警列表', 2)"
                  >
                    <p class="normal sum">
                      {{fireControlObj.yujingObj.totalCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'yj2' ? 'active' :　'' ]">
                        {{selectTime}}预警数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 3}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block4.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'gz' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('gz', '故障遗留未处理列表', 3)"
                >
                  故障遗留未处理
                  <span class="red">
                    {{fireControlObj.guzhangObj.unhandleCount}}
                  </span>
                  条
                </p>
                <div class="sum-wrap">
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('gz1', '故障' + selectTime + '已处理列表', 3)"
                  >
                    <p class="green sum">
                      {{fireControlObj.guzhangObj.handleCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'gz1' ? 'active' :　'' ]">
                        {{selectTime}}已处理数量
                      </span>
                    </p>
                  </div>
                  <div
                    class="sum-list"
                    @click.stop="spanClickDetail('gz2', selectTime + '故障列表', 3)"
                  >
                    <p class="normal sum">
                      {{fireControlObj.guzhangObj.totalCount}}
                    </p>
                    <p class="sum-text">
                      <span :class="[currentSpan == 'gz2' ? 'active' :　'' ]">
                        {{selectTime}}故障数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 详情 -->
        <transition
          name="trans_bot"
          mode="out-in"
        >
          <blockDetail
            @hideDetail="hideDetailFn"
            v-if="main_block_index!== '' && main_block_index < 5"
            :blockObj="blockObj"
            :class="{'active': main_block_index!== '' && main_block_index < 5}"
          ></blockDetail>
        </transition>
      </div>
      <!-- 设备总体情况 -->
      <div class="main-block-wrap">
        <div class="main-block-tit">
          设施总体情况

          <div
            v-if="deviceSitArr.length > 4"
            class="more-block"
            :class="{'active': moreBlockStatus}"
            @click='moreBlockFn'
          >
            <span>查看更多</span>
            <i class="iconfont">&#xe601;</i>
          </div>
        </div>
        <ul
          class="main-block-ul"
          :class="{'active': moreBlockStatus}"
        >
          <li
            v-if="deviceSitArr.indexOf('xfz') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 5}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block5.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'xfz' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('xfz', '消防主机列表', 5)"
                >
                  消防主机
                  <span class="normal">
                    {{deviceSituObj.xfzObj&&deviceSituObj.xfzObj.deviceTotal}}
                  </span>
                  台
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum"
                        :class="['red',currentSpan == 'xfz1'?'active': '']"
                        @click.stop="spanClickDetail('xfz1', '消防主机点位异常类型', 5)"
                      >
                        {{deviceSituObj.xfzObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum"
                        :class="['normal',currentSpan == 'xfz2'?'active': '']"
                        @click.stop="spanClickDetail('xfz2', '消防主机点位正常列表', 5)"
                      >
                        {{deviceSituObj.xfzObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'xfz1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('xfz1', '消防主机点位异常类型', 5)"
                      >
                        异常点数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'xfz2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('xfz2', '消防主机点位正常列表', 5)"
                      >
                        正常点数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('dq') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 6}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block6.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'dq' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('dq', '电气火灾监控系统', 6)"
                >
                  电气火灾监控
                  <span class="normal">
                    {{deviceSituObj.dqObj.deviceTotal}}
                  </span>
                  台
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('dq1', '电气火灾监控系统-异常', 6)"
                      >
                        {{deviceSituObj.dqObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('dq2', '电气火灾监控系统-正常设备', 6)"
                      >
                        {{deviceSituObj.dqObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'dq1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('dq1', '电气火灾监控系统-异常', 6)"
                      >
                        异常设备数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'dq2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('dq2', '电气火灾监控系统-正常设备', 6)"
                      >
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('qt') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 12}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block17.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'qt' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('qt', '其他设备列表', 12)"
                >
                  其他设备
                  <span class="normal">
                    {{deviceSituObj.qtObj.deviceTotal}}
                  </span>
                  台
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('qt1', '其他设备-异常',12)"
                      >
                        {{deviceSituObj.qtObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('qt2', '其他设备-正常',12)"
                      >
                        {{deviceSituObj.qtObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'qt1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('qt1', '其他设备-异常', 12)"
                      >
                        异常设备数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'qt2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('qt2', '其他设备-正常', 12)"
                      >
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('xfs') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 7}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block7.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'xfs' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('xfs', '消防水系统', 7)"
                >
                  消防水设备
                  <span class="normal">
                    {{deviceSituObj.xfsObj.deviceTotal}}
                  </span>
                  台
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('xfs1', '消防水系统-异常', 7)"
                      >
                        {{deviceSituObj.xfsObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('xfs2', '消防水系统-正常', 7)"
                      >
                        {{deviceSituObj.xfsObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'xfs1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('xfs1', '消防水系统-异常', 7)"
                      >
                        异常设备数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'xfs2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('xfs2', '消防水系统-正常', 7)"
                      >
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('tc') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 8}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block8.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'tc' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('tc', '独立探测器系统', 8)"
                >
                  独立式探测器
                  <span class="normal">
                    {{deviceSituObj.tcObj.deviceTotal}}
                  </span>
                  个
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('tc1', '独立探测器-异常', 8)"
                      >
                        {{deviceSituObj.tcObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('tc2', '独立探测器-正常', 8)"
                      >
                        {{deviceSituObj.tcObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'tc1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('tc1', '独立探测器-异常', 8)"
                      >
                        异常设备数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'tc2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('tc2', '独立探测器-正常', 8)"
                      >
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('zdmh') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 18}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block18.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'zdmh' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('zdmh', '自动灭火系统', 18)"
                >
                  自动灭火系统
                  <span class="normal">
                    {{deviceSituObj.zdmhObj.deviceTotal}}
                  </span>
                  个
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('zdmh1', '自动灭火-异常', 18)"
                      >
                        {{deviceSituObj.zdmhObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('zdmh2', '自动灭火-正常', 18)"
                      >
                        {{deviceSituObj.zdmhObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'zdmh1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('zdmh1', '自动灭火-异常', 18)"
                      >
                        异常设备数量
                      </span>
                      /
                      <span
                        :class="[currentSpan == 'zdmh2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('zdmh2', '自动灭火-正常', 18)"
                      >
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('kk') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 9}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block13.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  class="tit-count"
                  @click.stop="spanClickDetail('kk', '智能空开列表', 9)"
                >
                  智能空开
                  <span :class="deviceSituObj.kkObj.deviceTotal > 300 ? 'red' : deviceSituObj.kkObj.deviceTotal > 100 ? 'normal' : 'green'">
                    {{deviceSituObj.kkObj.deviceTotal}}
                  </span>
                  个
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum"
                        :class="deviceSituObj.kkObj.deviceError > 300 ? 'red' : deviceSituObj.kkObj.deviceError > 100 ? 'normal' : 'green'"
                        @click.stop="spanClickDetail('kk1', '智能空开-异常', 9)"
                      >
                        {{deviceSituObj.kkObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum"
                        :class="deviceSituObj.kkObj.deviceSuccess > 300 ? 'red' : deviceSituObj.kkObj.deviceSuccess > 100 ? 'normal' : 'green'"
                        @click.stop="spanClickDetail('kk2', '智能空开-正常', 9)"
                      >
                        {{deviceSituObj.kkObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span>
                        异常设备数量
                      </span>
                      /
                      <span>
                        正常设备数量
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('sp') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 10}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block14.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'sp' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('sp', '视频监控列表', 10)"
                >
                  视频监控
                  <span :class="deviceSituObj.spObj.deviceTotal > 300 ? 'red' : deviceSituObj.spObj.deviceTotal > 100 ? 'normal' : 'green'">
                    {{deviceSituObj.spObj.deviceTotal}}
                  </span>
                  台
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum"
                        :class="deviceSituObj.spObj.deviceError > 300 ? 'red' : deviceSituObj.spObj.deviceError > 100 ? 'normal' : 'green'"
                        @click.stop="spanClickDetail('sp1', '视频监控-异常', 10)"
                      >
                        {{deviceSituObj.spObj.deviceError}}
                      </span>
                      /
                      <span
                        class="sum"
                        :class="deviceSituObj.spObj.deviceSuccess > 300 ? 'red' : deviceSituObj.spObj.deviceSuccess > 100 ? 'normal' : 'green'"
                        @click.stop="spanClickDetail('sp2', '视频监控-正常', 10)"
                      >
                        {{deviceSituObj.spObj.deviceSuccess}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="{'active': currentSpan == 'sp1'}"
                        @click.stop="spanClickDetail('sp1', '视频监控-异常', 10)"
                      >
                        离线数量
                      </span>
                      <!--/-->
                      <span
                        :class="{'active': currentSpan == 'sp2'}"
                        @click.stop="spanClickDetail('sp2', '视频监控-正常', 10)"
                      >
                        在线数量
                      </span>
                      <!---->
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            v-if="deviceSitArr.indexOf('xj') != -1"
            class="main-block-li"
            :class="{'active' : main_block_index == 11}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block15.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'xj' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('xj', '巡检标签列表', 11)"
                >
                  巡检标签
                  <span class="green">
                    {{deviceSituObj.xjObj.deviceTotal}}
                  </span>
                  个
                </p>
              </div>
            </div>
          </li>
        </ul>
        <!-- 详情 -->
        <transition
          name="trans_bot"
          mode="out-in"
        >
          <blockDetail
            @hideDetail="hideDetailFn"
            v-if="main_block_index!== '' && (main_block_index >= 5) && (main_block_index <= 12||main_block_index==18)"
            :blockObj="blockObj"
            :class="{'active': main_block_index!== '' && (main_block_index >= 5) && (main_block_index <= 12||main_block_index==18)}"
          ></blockDetail>
        </transition>
      </div>
      <!-- 人员管理情况 -->
      <div class="main-block-wrap">
        <div class="main-block-tit">
          工作管理情况
        </div>
        <ul class="main-block-ul">
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 13}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block9.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'xc' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('xc', selectTime + '巡检标签列表', 13)"
                >
                  {{selectTime}}巡查检查任务
                  <span class="normal">
                    {{userManageObj.xunjianObj.total}}
                  </span>
                  个
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('xc1', selectTime +'巡查检查任务-超期任务', 13)"
                      >
                        {{userManageObj.xunjianObj.overTime}}
                      </span>
                      /
                      <span
                        class="sum org"
                        @click.stop="spanClickDetail('xc2', selectTime +'巡查检查任务-进行任务', 13)"
                      >
                        {{userManageObj.xunjianObj.doing}}
                      </span>
                      /
                      <span
                        class="sum"
                        :class="userManageObj.xunjianObj.done > 300 ? 'red' : userManageObj.xunjianObj.done > 100 ? 'normal' : 'green'"
                        @click.stop="spanClickDetail('xc3', selectTime +'巡查检查任务-完成任务', 13)"
                      >
                        {{userManageObj.xunjianObj.done}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'xc1' ? 'active': '']"
                        @click.stop="spanClickDetail('xc1', selectTime +'巡查检查任务-超期任务', 13)"
                      >超期任务</span>/<span
                        :class="[currentSpan == 'xc2' ? 'active': '']"
                        @click.stop="spanClickDetail('xc2', selectTime +'巡查检查任务-进行任务', 13)"
                      >进行任务</span>/<span
                        :class="[currentSpan == 'xc3' ? 'active': '']"
                        @click.stop="spanClickDetail('xc3', selectTime +'巡查检查任务-完成任务', 13)"
                      >完成任务</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 14}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block10.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'yh' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('yh', selectTime+'隐患遗留未处理列表', 14)"
                >
                  隐患遗留未处理
                  <span class="red">
                    {{userManageObj.yinhuanObj.total}}
                  </span>
                  条
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum green"
                        @click.stop="spanClickDetail('yh1', '隐患' + selectTime + '已处理列表', 14)"
                      >
                        {{userManageObj.yinhuanObj.todayDeal}}
                      </span>
                      /
                      <span
                        class="sum normal"
                        @click.stop="spanClickDetail('yh2', '隐患遗留未处理列表', 14)"
                      >
                        {{userManageObj.yinhuanObj.todayTotal}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'yh1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('yh1', '隐患' + selectTime + '已处理列表', 14)"
                      >{{selectTime}}已处理数量</span>/<span
                        :class="[currentSpan == 'yh2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('yh2', '隐患遗留未处理列表', 14)"
                      >{{selectTime}}隐患数量</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 15}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block11.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'cg' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('cg', selectTime + '查岗次数统计', 15)"
                >
                  {{selectTime}}查岗
                  <span class="normal">
                    {{userManageObj.chagangObj.total}}
                  </span>
                  次
                  <img
                    class="check-img"
                    src="../assets/images/company_layer/block-ico/check.png"
                    alt=""
                    @click.stop="spanClickDetail('cg3', '值班查岗', 15)"
                  >
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('cg1', selectTime + '离岗次数统计', 15)"
                      >
                        {{userManageObj.chagangObj.outStation}}
                      </span>
                      /
                      <span
                        class="sum green"
                        @click.stop="spanClickDetail('cg2', selectTime + '在岗次数统计', 15)"
                      >
                        {{userManageObj.chagangObj.inStation}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'cg1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('cg1', selectTime + '离岗次数统计', 15)"
                      >离岗次数</span>/<span
                        :class="[currentSpan == 'cg2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('cg2', selectTime + '在岗次数统计', 15)"
                      >在岗次数</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="main-block-li"
            :class="{'active' : main_block_index == 16}"
          >
            <div class="main-block">
              <img
                src="../assets/images/company_layer/block-ico/block12.png"
                alt=""
              >
              <div class="info-wrap">
                <p
                  :class="['tit-count', currentSpan == 'px' ? 'active' :　'' ]"
                  @click.stop="spanClickDetail('px', '培训演练次数统计', 16)"
                >
                  培训演练任务
                  <span class="normal">
                    {{userManageObj.peixunObj.total}}
                  </span>
                  个
                </p>
                <div class="sum-wrap">
                  <div class="sum-list">
                    <div>
                      <span
                        class="sum red"
                        @click.stop="spanClickDetail('px1', '培训演练超期未完成次数统计', 16)"
                      >
                        {{userManageObj.peixunObj.doing}}
                      </span>
                      /
                      <span
                        class="sum org"
                        @click.stop="spanClickDetail('px2', '培训演练正常任务次数统计', 16)"
                      >
                        {{userManageObj.peixunObj.overDoing}}
                      </span>
                      /
                      <span
                        class="sum green"
                        @click.stop="spanClickDetail('px3', '培训演练完成任务次数统计', 16)"
                      >
                        {{userManageObj.peixunObj.complete}}
                      </span>
                    </div>
                    <p class="sum-text">
                      <span
                        :class="[currentSpan == 'px1' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('px1', '培训演练超期未完成次数统计', 16)"
                      >超期未完成</span>/<span
                        :class="[currentSpan == 'px2' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('px2', '培训演练正常任务次数统计', 16)"
                      >正常进行任务</span>/<span
                        :class="[currentSpan == 'px3' ? 'active' :　'' ]"
                        @click.stop="spanClickDetail('px3', '培训演练完成任务次数统计', 16)"
                      >完成任务（正常完成，超期完成）</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- 详情 -->
        <transition
          name="trans_bot"
          mode="out-in"
        >
          <blockDetail
            @hideDetail="hideDetailFn"
            @todayCg="todayCg"
            v-if="main_block_index!== '' && (main_block_index >= 13) &&(main_block_index < 17)"
            :blockObj="blockObj"
            :class="{'active': main_block_index!== '' && (main_block_index >= 13) && (main_block_index < 17)}"
          ></blockDetail>
        </transition>
      </div>
    </div>
    <modal
      :optionBtnIndex="optionBtnIndex"
      @modalClose="modalClose"
    ></modal>
  </div>
</template>
<script>
import newClose from "@/assets/img/newClose.png";
import modal from "./base-layer-modal.vue";
import blockDetail from "./base-layer-block-detail.vue";
import { blcok_sum, contBlockUrl } from "@/assets/js/url.js";

import marker3Img from "@/assets/marker/ico3.png"; //故障
export default {
  name: "",
  data: () => ({
    marker3Img,
    baseInfoItem: {},
    loginData: "",
    hashValue: "",
    newClose,
    switch1: false,
    autoUpdateTimer: null,
    timeIndex: 0,
    timeArr: ["今日", "本周", "本月"],
    dateType: "thisDay",
    selectTime: "今日", //当前时间类型
    map: null,
    xfSum: 2323,
    sum: 23,
    sum1: 232,
    main_block_index: "",
    moreBlockStatus: false,
    optionBtnIndex: "",
    optionBtnArr: [
      {
        label: "人员信息",
        value: 0,
        btn_type: 0,
      },
      {
        label: "相关图档",
        value: 0,
        btn_type: 1,
      },
      {
        label: "重点部位",
        value: 0,
        btn_type: 2,
      },
      {
        label: "周边资源",
        value: 0,
        btn_type: 3,
      },
      {
        label: "建筑构物",
        value: 0,
        btn_type: 4,
      },
      {
        label: "预案管理",
        value: 0,
        btn_type: 5,
      },
    ],
    blockObj: {
      blockType: "",
      title: "",
    },
    currentPage: 1,
    fireControlObj: {
      huojingObj: {
        totalCount: 0,
        handleCount: 0,
        unhandleCount: 0,
      },
      baojingObj: {
        totalCount: 0,
        handleCount: 0,
        unhandleCount: 0,
      },
      yujingObj: {
        totalCount: 0,
        handleCount: 0,
        unhandleCount: 0,
      },
      guzhangObj: {
        totalCount: 0,
        handleCount: 0,
        unhandleCount: 0,
      },
    },
    deviceSituObj: {
      xfzObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      dqObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      qtObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      xfsObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      tcObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      kkObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      spObj: {
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      },
      xjObj: {
        deviceTotal: 0,
      },
      zdmhObj:{
        deviceTotal: 0,
        deviceSuccess: 0,
        deviceError: 0,
      }
    },
    userManageObj: {
      xunjianObj: {
        doing: 0,
        done: 0,
        overTime: 0,
        total: 0,
      },
      yinhuanObj: {
        todayDeal: 0,
        todayTotal: 0,
        total: 0,
      },
      chagangObj: {
        inStation: 0,
        outStation: 0,
        total: 0,
      },
      peixunObj: {
        doing: 0,
        overDoing: 0,
        complete: 0,
        total: 0,
      },
    },
    currentSpan: "",
    deviceSitArr: [],
    baseInfoTitle: "",
    flg: false,
  }),
  watch: {
    showLayer: {
      handler(newVal, oldVal) {
        if (newVal) {
          //获取数据
        }
      },
      immediate: true,
      deep: true,
    },
    showLayerId: {
      handler(newVal, oldVal) {
        // console.log(newVal);
        // console.log('列表点击id');
        // console.log(this.$store.state.baseInfoLayer.baseInfoItem);
        this.main_block_index = "";
        this.currentSpan = "";
        this.blockObj = {
          blockType: "",
          title: "",
        };
        this.baseInfoItem = {};
        if (newVal) {
          //获取数据
          // this.baseInfoItem = this.$store.state.baseInfoLayer.baseInfoItem;
          this.baseInfoTitle = this.$store.state.baseInfoLayer.baseInfoTitle;
          this.getBaseInfo(); //获取基础数据

          this.getBlockSum(); //获取右侧6个块数据
          this.fireControl(); //获取消防运行情况
          this.deviceSituation(); //设备总体情况
          this.userManage(); //人员管理情况
          this.modalClose(); //关闭右上角按钮弹窗
        }
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    modal,
    blockDetail,
  },
  created() {},
  mounted() {
    this.hashValue = window.localStorage.getItem("hashValue");
    this.loginData = JSON.parse(window.localStorage.getItem("loginData"));
    $JQ("#base-layer-detail-body").mCustomScrollbar();
    // $('.layer-body-wrap').mCustomScrollbar();
  },
  computed: {
    showLayer() {
      return this.$store.state.baseInfoLayer.detailStatus;
    },
    showLayerId() {
      return this.$store.state.baseInfoLayer.baseInfoId;
    },
  },
  methods: {
    getBaseInfo() {
      var data = {
        type: "get",
        url: `mcbw/departments/${this.showLayerId}`,
        obj: {},
      };
      this.$Axios(data)
        .then((res) => {
          console.log(res);
          if (res.data.success && res.data.data) {
            this.baseInfoItem = res.data.data;
          } else {
            // this.baseInfoItem = this.$store.state.baseInfoLayer.baseInfoItem;
          }

          this.mapInit();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    modalClose(res) {
      this.optionBtnIndex = "";
      this.$store.commit("eventStatis", {
        status: false,
        id: "",
        type: "",
      });
      this.$store.commit("showDetail", {
        status: false,
        item: {},
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });
    },
    closeLayer() {
      this.$store.commit("baseInfoLayer", {
        detailStatus: false,
      });
      this.$store.commit("departInfoLayer", 2);
    },
    switchChange() {
      console.log(this.switch1);
      if (this.switch1) {
        //自动刷新 1分钟
        this.autoUpdateTimer = setInterval(() => {
          this.update();
        }, 60000);
      } else {
        //取消自动刷新
        clearInterval(this.autoUpdateTimer);
      }
    },
    update() {
      //手动刷新数据
      this.getBlockSum(); //获取右侧6个块数据
      this.fireControl(); //获取消防运行情况
      this.deviceSituation();
      this.userManage(); //人员管理情况
    },
    changeTime(index) {
      this.timeIndex = index;
      this.selectTime = this.timeArr[index];
      switch (this.timeIndex) {
        case 0:
          this.dateType = "thisDay";
          break;
        case 1:
          this.dateType = "thisWeek";
          break;
        case 2:
          this.dateType = "thisMonth";
          break;
      }
      // 隐藏块下拉框
      this.flg = false;
      this.main_block_index = "";
      this.currentSpan = "";
      this.blockObj = {
        blockType: "",
        title: "",
      };
      this.update(); //刷新数据
    },
    fireControl() {
      let _this = this;
      let dateType = this.dateType;
      const hj = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.xfBlock,
            obj: {
              // currentPage: this.currentPage,
              // pageSize: 50,
              orgId: _this.$store.state.baseInfoLayer.baseInfoId,
              alarmType: "fire",
              dateType: dateType,
            },
          };
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("消防运行情况--火警类型数据");
            if (res.data.success) {
              console.log(res.data.data);
              _this.fireControlObj.huojingObj = res.data.data;
              resolve();
            }
          });
        });
      };
      const bj = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.xfBlock,
            obj: {
              // currentPage: this.currentPage,
              // pageSize: 50,
              orgId: _this.$store.state.baseInfoLayer.baseInfoId,
              alarmType: "alarm",
              dateType: dateType,
            },
          };
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("消防运行情况--报警类型数据");
            if (res.data.success) {
              console.log(res.data.data);
              _this.fireControlObj.baojingObj = res.data.data;
              resolve();
            }
          });
        });
      };
      const yj = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.xfBlock,
            obj: {
              // currentPage: this.currentPage,
              // pageSize: 50,
              orgId: _this.$store.state.baseInfoLayer.baseInfoId,
              alarmType: "warn",
              dateType: dateType,
            },
          };
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("消防运行情况--预警类型数据");
            if (res.data.success) {
              console.log(res.data.data);
              _this.fireControlObj.yujingObj = res.data.data;
              resolve();
            }
          });
        });
      };
      const gz = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.xfBlock,
            obj: {
              // currentPage: this.currentPage,
              // pageSize: 50,
              orgId: _this.$store.state.baseInfoLayer.baseInfoId,
              alarmType: "fault",
              dateType: dateType,
            },
          };
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("消防运行情况--故障类型数据");
            if (res.data.success) {
              console.log(res.data.data);
              _this.fireControlObj.guzhangObj = res.data.data;
              resolve();
            }
          });
        });
      };

      async function getData() {
        await hj();
        await bj();
        await yj();
        await gz();
      }
      getData();
    },
    deviceSituation() {
      let _this = this;
      var data = {
        type: "get",
        url: contBlockUrl.deviceTypeBlock,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
        },
      };
      // 巡查巡检
      _this.$Axios(data).then((res) => {
        console.log(res);
        console.log("设备总体情况接口");
        if (res.data.success) {
          console.log(res.data.data);
          let arr = [];
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].type == 0) {
              arr.push("xfz");
              this.deviceSituationBlock(
                res.data.data[i],
                "xfz",
                "消防主机数据"
              );
            }
            if (
              res.data.data[i].type == 3 &&
              res.data.data[i].systemForms == "15"
            ) {
              arr.push("dq");
              this.deviceSituationBlock(res.data.data[i], "dq", "电气火灾");
            }
            /*新增其他设备*/
            if (
              res.data.data[i].type == 3 &&
              res.data.data[i].systemForms == "99"
            ) {
              arr.push("qt");
              this.deviceSituationBlock(res.data.data[i], "qt", "其他设备");
            }
            if (
              res.data.data[i].type == 3 &&
              (res.data.data[i].systemForms == "2" ||
                res.data.data[i].systemForms == "4" ||
                res.data.data[i].systemForms == "2,4")
            ) {
              arr.push("xfs");
              this.deviceSituationBlock(res.data.data[i], "xfs", "消防水设备");
            }
            if (
              res.data.data[i].type == 3 &&
              res.data.data[i].systemForms == "28"
            ) {
              arr.push("tc");
              this.deviceSituationBlock(res.data.data[i], "tc", "独立探测器");
            }
             if (res.data.data[i].type == 3 &&res.data.data[i].systemForms == "32") {
              arr.push("zdmh");
              this.deviceSituationBlock(res.data.data[i], "zdmh", "自动灭火");
            }
            // if(res.data.data[i].type == 3 && res.data.data[i].systemForms == '22'){
            //   arr.push('kk');
            //   this.deviceSituationBlock(res.data.data[i], 'kk', '智能空开');
            // }
            if (res.data.data[i].type == 1) {
              arr.push("sp");
              this.deviceSituationBlock(res.data.data[i], "sp", "视频");
            }
            if (res.data.data[i].type == 2) {
              arr.push("xj");
              this.deviceSituationBlock(res.data.data[i], "xj", "巡检标签");
            }
          }
          this.deviceSitArr = arr;
        }
      });
    },
    deviceSituationBlock(obj, dataType, tit) {
      // deviceBlock
      console.log(obj);
      let _this = this;
      var data = {
        type: "get",
        url: contBlockUrl.deviceBlock,
        obj: {
          orgId: _this.$store.state.baseInfoLayer.baseInfoId,
          type: obj.type,
        },
      };
      if (obj.type == 3) {
        data.obj["systemForms"] = obj.systemForms;
      }
      _this.$Axios(data).then((res) => {
        if (res.data.success) {
          switch (dataType) {
            case "xfz":
              _this.deviceSituObj.xfzObj = res.data.data.device;
              break;
            case "dq":
              _this.deviceSituObj.dqObj = res.data.data.device;
              break;
            //新增其他
            case "qt":
              _this.deviceSituObj.qtObj = res.data.data.device;
              break;
            case "xfs":
              _this.deviceSituObj.xfsObj = res.data.data.device;
              break;
            case "tc":
              _this.deviceSituObj.tcObj = res.data.data.device;
              break;
            case "kk":
              _this.deviceSituObj.kkObj = res.data.data.device;
              break;
            case "sp":
              _this.deviceSituObj.spObj = res.data.data.device;
              break;
            case "xj":
              _this.deviceSituObj.xjObj = res.data.data.device;
              break;
            case "zdmh":
              _this.deviceSituObj.zdmhObj = res.data.data.device;
              break;
          }
        }
      });
    },
    userManage() {
      //人员管理情况

      let _this = this;
      let dateType = this.dateType;
      const xj = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.xcBlock,
            obj: {
              executeOrgId: _this.$store.state.baseInfoLayer.baseInfoId,
              dateType: dateType,
            },
          };
          // 巡查巡检
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("人员管理--巡查巡检接口");
            if (res.data.success) {
              console.log(res.data.data);
              _this.userManageObj.xunjianObj = res.data.data;
              resolve();
            }
          });
        });
      };

      const yh = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.yhBlock,
            obj: {
              orgId: _this.$store.state.baseInfoLayer.baseInfoId,
              dateType: dateType,
            },
          };
          // 巡查巡检
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("人员管理--隐患接口");
            if (res.data.success) {
              console.log(res.data.data);
              _this.userManageObj.yinhuanObj = res.data.data;
              resolve();
            }
          });
        });
      };

      const cg = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.cgBlock,
            obj: {
              checkedOrgId: _this.$store.state.baseInfoLayer.baseInfoId,
              dateType: dateType,
            },
          };
          // 巡查巡检
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("人员管理--查岗接口");
            if (res.data.success) {
              console.log(res.data.data);
              _this.userManageObj.chagangObj = res.data.data;
              resolve();
            }
          });
        });
      };
      // 培训演练
      const px = function (params) {
        return new Promise((resolve, reject) => {
          var data = {
            type: "get",
            url: contBlockUrl.pxBlock,
            obj: {
              executeOrgId: _this.$store.state.baseInfoLayer.baseInfoId,
            },
          };
          // 巡查巡检
          _this.$Axios(data).then((res) => {
            console.log(res);
            console.log("人员管理--培训演练接口");
            if (res.data.success) {
              console.log(res.data.data);
              _this.userManageObj.peixunObj = res.data.data;
              resolve();
            }
          });
        });
      };
      async function getData() {
        await xj();
        await yh();
        await cg();
        await px();
      }
      getData();
    },
    getBlockSum() {
      let _this = this;
      // blcok_sum
      let orgId = JSON.parse(window.localStorage.getItem("loginData")).orgId;
      var data = {
        type: "get",
        url: blcok_sum,
        obj: {
          currentPage: this.currentPage,
          pageSize: 50,
          orgId: this.$store.state.baseInfoLayer.baseInfoId,
          name: "",
          userType: 1,
          floor: "",
          buildingId: "",
          importantPartType: "",
          description: "",
          buildingImgType: "",
          code: "",
          executeOrgId: this.$store.state.baseInfoLayer.baseInfoId,
        },
      };
      _this.$Axios(data).then((res) => {
        console.log(res);
        console.log("右侧6个块");
        if (res.data.success) {
          console.log(res.data.data);
          _this.optionBtnArr[0].value = res.data.data.userCount;
          _this.optionBtnArr[1].value = res.data.data.relatedDrawings;
          _this.optionBtnArr[2].value = res.data.data.keyParts;
          _this.optionBtnArr[3].value = res.data.data.surroundingResources;
          _this.optionBtnArr[4].value = res.data.data.buildingStructures;
          _this.optionBtnArr[5].value = res.data.data.reservePlan;
        }
      });
    },
    mapInit() {
      //初始化地图
      if (!this.baseInfoItem.position) {
        return;
      }
      let position = [
        this.baseInfoItem.position.split(",")[0],
        this.baseInfoItem.position.split(",")[1],
      ];
      console.log(position);
      this.$nextTick(() => {
        this.map = new AMap.Map("company-map", {
          resizeEnable: true,
          center: position,
          zooms: [3, 17.5],
          mapStyle: "amap://styles/8015939191c19f9d3889fb6066703978",
          dragEnable: false,
          zoomEnable: false,
        });
        this.testevent(); //点击单位地图
        let labelMarker = new AMap.LabelMarker({
          position: position,
          zIndex: 16,
          // 将第一步创建的 icon 对象传给 icon 属性
          icon: {
            // 图标类型，现阶段只支持 image 类型
            type: "image",
            // 图片 url
            image: marker3Img,
            // 图片尺寸
            size: [20, 30],
            // 图片相对 position 的锚点，默认为 bottom-center
            anchor: "center",
          },
        });
        var labelsLayer = new AMap.LabelsLayer({
          zooms: [3, 20],
          zIndex: 1000,
          // 该层内标注是否避让
          collision: false,
          // 设置 allowCollision：true，可以让标注避让用户的标注
          allowCollision: false,
        });
        labelsLayer.add(labelMarker);
        this.map.add(labelsLayer);
      });
    },
    testevent() {
      let that = this;
      AMap.event.addListener(that.map, "click", function () {
        //添加点击事件,传入对象名，事件名，回调函数
        //展厅   公司    厂房   寰宇测绘
        // if(that.$store.state.baseInfoLayer.baseInfoId == 127594 || that.$store.state.baseInfoLayer.baseInfoId == 130 || that.$store.state.baseInfoLayer.baseInfoId == 133460  || that.$store.state.baseInfoLayer.baseInfoId == 148978){
        that.optionBtn(7);
        // }else{
        //     alert('该单位未开发此功能！')
        // }
      });
    },
    optionBtn(index) {
      //右上角按钮点击
      this.$store.commit("eventStatis", {
        status: false,
        id: "",
        type: "",
      });
      this.$store.commit("showDetail", {
        status: false,
        item: {},
      });
      this.$store.commit("showMap", {
        status: false,
        position: null,
      });
      this.$store.commit("showCrtMap", {
        status: false,
        item: {},
      });
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });

      this.optionBtnIndex = index;
    },
    spanClickDetail(spanType, title, index) {
      this.$store.commit("monitor", {
        status: false,
        id: "",
        type: "",
        item: {},
      });
      if (this.flg && this.currentSpan == spanType) {
        this.flg = false;
        this.main_block_index = "";
        this.currentSpan = "";
        this.blockObj = {
          blockType: "",
          title: "",
        };
      } else {
        this.flg = true;
        this.main_block_index = index;
        this.currentSpan = spanType;
        let obj = {
          blockType: spanType,
          title: title,
          dateType: this.dateType,
        };
        this.blockObj = obj;
      }
      console.log(spanType);
      // this.currentSpan = spanType;
      // let obj = {
      //   blockType: spanType,
      //   title: title,
      //   dateType: this.dateType,
      // }
      // this.blockObj = obj;
      //   console.log(this.blockObj);
    },
    mainBlock(index) {
      if (this.flg && this.main_block_index == index) {
        this.flg = false;
        this.main_block_index = "";
        this.blockObj = {
          blockType: "",
          title: "",
        };
      } else {
        this.flg = true;
        this.main_block_index = index;
        this.currentSpan = "";
        let obj = {
          blockType: "",
          title: "",
        };
        obj["dateType"] = this.dateType;
        this.blockObj = obj;
      }
    },
    moreBlockFn() {
      this.moreBlockStatus = !this.moreBlockStatus;
    },
    hideDetailFn() {
      //隐藏下拉框
      this.flg = false;
      this.main_block_index = "";
      this.currentSpan = "";
      this.blockObj = {
        blockType: "",
        title: "",
      };
    },
    todayCg() {
      return new Promise((resolve, reject) => {
        var data = {
          type: "get",
          url: contBlockUrl.cgBlock,
          obj: {
            checkedOrgId: this.$store.state.baseInfoLayer.baseInfoId,
            dateType: this.dateType,
          },
        };
        this.$Axios(data).then((res) => {
          if (res.data.success) {
            console.log(res.data.data);
            this.userManageObj.chagangObj = res.data.data;
            resolve();
          }
        });
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.autoUpdateTimer);
  },
};
</script>
<style lang="scss" scoped>
.trans-enter,
.trans-leave-to {
  transform: translateX(calc(100vw - 500px));
}
.trans-enter-active,
.trans-leave-active {
  transition: all 0.3s;
}
.detail-layer-wrap {
  position: absolute;
  top: 87px;
  right: 0;
  color: #fff;
  height: calc(100vh - 87px);
  width: calc(100vw - 505px);
  /*padding: 0 15px 15px 25px;*/
  padding: 0;
  background: rgba(6, 18, 44, 1) url("../assets/img/blockBg.png") center
    center/100% 100% no-repeat;
  z-index: 160;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  // 顶部样式
  .layer-head-wrap {
    position: relative;
    .btn-wrap {
      position: absolute;
      left: 15px;
      top: 20px;
      .close-btn {
        width: 19px;
        height: 18px;
        cursor: pointer;
      }
    }
    .layer-head-main {
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .company-info {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding-left: 80px;
        .company-name {
          color: #74d9ff;
          max-width: 200px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 21px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 28px;
        }
        .contacts-wrap {
          width: 550px;
          table {
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            td {
              text-align: left;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #7db4db;
              line-height: 28px;
              &:nth-child(1),
              &:nth-child(3) {
                text-align: right;
              }
            }
            .text-space {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .option-group {
        width: 400px;
        display: flex;
        align-items: center;
        .update-wrap {
          display: flex;
          align-items: center;
          .auto-text {
            font-size: 14px;
            color: #74d9ff;
          }
          /deep/ .ivu-switch {
            margin: 0 10px;
            //background-color: #6d9fc3;
            //border-color: #6d9fc3;
            &:after {
             // background-color: #b5d7ef;
            }
          }
        }
        .time-wrap {
          margin-left: 30px;
          display: flex;
          align-items: center;
          li {
            font-size: 18px;
            padding: 0 10px;
            cursor: pointer;
            position: relative;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #a2d8ff;
            line-height: 28px;
            opacity: 0.45;
            /* &:not(:first-child)::before{
                content: '';
                position: absolute;
                left: -1px;
                top: 4px;
                width: 2px;
                height: 16px;
                background: rgba(8,244,247,.3);
              }*/
            &.active {
              color: #a2d8ff;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .layer-body-wrap {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    /deep/ .mCSB_inside > .mCSB_container {
      margin-right: 0;
    }
    .option-wrap {
      height: 220px;
      margin-bottom: 10px;
      padding: 15px;
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      box-shadow: inset 0 0 35px #173c71;
      .equal_ul {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .equal_li {
          width: 25%;
          height: 190px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .table-wrap {
        // width: 310px;
        table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
          td {
            font-size: 13px;
            color: #74d9ff;
            text-align: left;
            vertical-align: top;
            &:first-child {
              color: #b9c0c4;
              text-align: right;
            }
          }
        }
      }
      .map-wrap {
        // flex: 1;
        // flex-shrink: 0;
        // overflow: hidden;
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;
        .company-map {
          width: 100%;
          height: 180px;
          background: #001a29;
          box-shadow: inset 0 0 17px #173c71;
        }
      }
      .map-img-wrap {
        // margin-left: 20px;
        width: 220px;
        height: 180px;
        box-shadow: inset 0 0 17px #173c71;
        img {
          width: 100px;
          margin: 40px auto 10px;
        }
        p {
          text-align: center;
        }
      }
      .option-btn-wrap {
        ul {
          font-size: 0;
          width: 300px;
          li {
            display: inline-block;
            vertical-align: top;
            width: 142px;
            height: 32px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #50e3c2;
            border-radius: 10px;
            font-size: 14px;
            color: #50e3c2;
            margin-top: 20px;
            cursor: pointer;
            transition: all 0.3s;
            &:nth-child(1),
            &:nth-child(2) {
              margin-top: 0;
            }
            &:nth-child(even) {
              margin-left: 15px;
            }
            &:nth-child(1) {
              border: 1px solid #c35518;
              color: #c35518;
              &.active {
                background: #c35518;
                color: #fff;
              }
            }
            &:nth-child(2) {
              border: 1px solid #6ae956;
              color: #6ae956;
              &.active {
                background: #6ae956;
                color: #fff;
              }
            }
            &:nth-child(3) {
              border: 1px solid #e2be3f;
              color: #e2be3f;
              &.active {
                background: #e2be3f;
                color: #fff;
              }
            }
            &:nth-child(4) {
              border: 1px solid #9a7b1b;
              color: #9a7b1b;
              &.active {
                background: #9a7b1b;
                color: #fff;
              }
            }
            &:nth-child(5) {
              border: 1px solid #5ba7cd;
              color: #5ba7cd;
              &.active {
                background: #5ba7cd;
                color: #fff;
              }
            }
            &:nth-child(6) {
              border: 1px solid #c7595a;
              color: #c7595a;
              &.active {
                background: #c7595a;
                color: #fff;
              }
            }
          }
        }
      }
    }
    .main-block-wrap {
      padding: 15px;
      margin-bottom: 10px;
      box-shadow: inset 0 0 17px #173c71;
      &:last-child {
        margin-bottom: 0;
      }
      .main-block-tit {
        color: #a2d8ff;
        font-size: 20px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(to right, #60aed4 0%, #041936 20%);
        text-indent: 8px;
        img {
          margin-left: 7px;
        }
        .more-block {
          display: flex;
          align-items: center;
          font-size: 14px;
          cursor: pointer;
          i {
            font-size: 16px;
            margin-left: 5px;
            transition: all 0.3s;
          }
          &.active {
            i {
              transform: rotateZ(180deg);
            }
          }
        }
      }
      .main-block-ul {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
        max-height: 112px;
        transition: all 0.3s;
        &.active {
          max-height: 500px;
        }
        .main-block-li {
          width: 25%;
          .main-block {
            width: 325px;
            height: 112px;
            padding: 10px;
            border-radius: 12px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            transition: all 0.3s;
            img {
              width: 80px;
              height: 80px;
            }
            .info-wrap {
              margin-left: 25px;
              .tit-count {
                font-size: 14px;
                line-height: 14px;
                color: #b9c0c4;
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                &.active {
                  color: #74d9ff;
                }
                span {
                  font-size: 20px;
                  margin: 0 5px;
                  &.normal {
                    color: #74d9ff;
                  }
                  &.red {
                    color: #ee2c2c;
                  }
                  &.green {
                    color: #72d00b;
                  }
                  &.org {
                    color: #f5a623;
                  }
                }
                .check-img {
                  width: 25px;
                  height: 25px;
                  margin-left: 10px;
                  cursor: pointer;
                }
              }
              .sum-wrap {
                display: flex;
                justify-content: space-between;
                .sum-list {
                  .sum {
                    font-size: 20px;
                    &.normal {
                      color: #74d9ff;
                    }
                    &.red {
                      color: #ee2c2c;
                    }
                    &.green {
                      color: #72d00b;
                    }
                    &.org {
                      color: #f5a623;
                    }
                  }
                  .sum-text {
                    font-size: 12px;
                    color: #b9c0c4;
                    span {
                      transition: all 0.3s;
                      margin: 0 3px;
                      &.active {
                        color: #74d9ff;
                      }
                    }
                  }
                }
              }
            }
          }
          &.active {
            .main-block {
              background: rgba(216, 216, 216, 0.2);
              box-shadow: 0px 1px 9px 4px #656d76 inset;
              .tit-count {
                color: #b9c0c4;
              }
            }
          }
        }
      }
    }
  }
}
.blockThree {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
}
// .mapOneTwo{
//   width: 600px !important;
//   margin-left: 60px !important;
// }
</style>


// WEBPACK FOOTER //
// src/components/base-layer-detail.vue